<template>
  <div>
    <el-tabs
      :tab-position="tabPosition"
      v-model="active_vctab"
      @tab-click="tabClick"
    >
      <el-tab-pane label="Collective overview" name="collective_overview">
        <el-row class="pb-3 mt10">
          <el-col class="tab-select" :span="24">
            <el-select
              class="float-left"
              v-model="collective_value"
              placeholder="Choose data"
              @change="showCollectiveData(collective_value)"
            >
              <el-option
                v-for="item in collective_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="tab-select flex-center" v-if="collective_value === 'active_track_campaigns'">
          <el-col :span="24" :lg="14">
            <h1>Total active track campaigns</h1>
            <GChart class="flex-center"
              type="LineChart"
              :data="active_track_campaigns"
              :options="LineChartSett"
            />
          </el-col>
        </el-row>
        <el-row class="tab-select flex-center" v-if="collective_value === 'vc_spent'">
          <el-col :span="24" :lg="14">
            <h1>Total spent VidCents</h1>
            <GChart class="flex-center"
              type="LineChart"
              :data="vc_spent"
              :options="LineChartSett"
            />
          </el-col>
        </el-row>
        <el-row class="tab-select flex-center" v-if="collective_value === 'vc_views'">
          <el-col :span="24" :lg="14">
            <h1>Total VidCents views</h1>
            <GChart class="flex-center"
              type="LineChart"
              :data="vc_views"
              :options="LineChartSett"
            />
          </el-col>
        </el-row>
        <el-row class="tab-select flex-center" v-if="collective_value === 'vc_available'">
          <el-col :span="24" :lg="14">
            <h1>Total available VidCents</h1>
            <GChart class="flex-center"
              type="LineChart"
              :data="vc_available"
              :options="LineChartSett"
            />
          </el-col>
        </el-row>
        <el-row class="tab-select flex-center" v-if="collective_value === 'yt_video_no'">
          <el-col :span="24" :lg="14">
            <h1>Total No. YouTube videos</h1>
            <GChart class="flex-center"
              type="LineChart"
              :data="yt_video_no"
              :options="LineChartSett"
            />
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="Campaigns overview" name="cp_overview">
        <el-radio-group class="mt10 ml10" v-model="campaings_value">
          <el-radio v-for="item in campaings_options" :key="item.value" :label="item.value">{{item.label}}</el-radio>
        </el-radio-group>
        <el-date-picker
          v-model="reports_date_range"
          class="float-right mt10"
          type="daterange"
          unlink-panels
          range-separator="-"
          start-placeholder="Start date"
          end-placeholder="End date"
          :picker-options="dateRangeOptions"
          format="d MMMM yyyy"
          value-format="yyyy-MM-dd"
          @change="filter()"
        ></el-date-picker>
        <el-row>
          <el-col :span="24">
            <h1>Campaigns overview - {{ campaings_value }} campaigns</h1>
          </el-col>
        </el-row>
        <el-row>
          <el-select v-model="choosen_label" placeholder="Labels" 
          v-if="campaings_value === 'by label'"
              @change="readLabel(labels.data)">
            <el-option
              v-for="item in labels.data"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-row>
        <el-row class="tab-select flex-center" v-if="campaings_value === 'all'">
          <el-col :span="24" :lg="14">
            <GChart class="flex-center"
              type="LineChart"
              :data="active_track_campaigns"
              :options="LineChartSett"
            />
          </el-col>
        </el-row>
        <el-row v-if="campaings_value === 'by label'">
          <el-col class="tab-select" :span="24">
            <h4>No. Campaigns: {{vc_label.length}}</h4>
            <el-table :data="vc_label" class="w100" stripe >
              <el-table-column
                label="Campaing name"
                prop="name"
                width="300"
                sortable
              ></el-table-column>
              <el-table-column label="Start date" prop="created_at" sortable>
                <template slot-scope="props">
                  {{ props.row.created_at | date }}
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="End date"
                prop="views"
                sortable
              ></el-table-column>
              <el-table-column
                label="VidCents budget"
                prop="subscribers"
                sortable
              ></el-table-column>
              <el-table-column
                label="VidCents paid out"
                prop="date"
                sortable
              ></el-table-column>
              <el-table-column
                label="Total views"
                prop="date"
                sortable
              ></el-table-column> -->
            </el-table>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="VidCents overview" name="vc_overview">
        <el-radio-group class="mt10 ml10" v-model="vidcents_value">
          <el-radio v-for="item in vidcents_options" :key="item.value" :label="item.value">{{item.label}}</el-radio>
        </el-radio-group>
        <el-row>
          <h1>
            Available VidCents - {{ vidcents_value }} on
            <strong>{{ today }}</strong>
          </h1>
        </el-row>
        <el-row>
          <el-select v-model="choosen_label" placeholder="Labels" 
          v-if="vidcents_value === 'by label'">
            <el-option
              v-for="item in labels.data"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-row>
        <el-row>
          <el-col :span="24" :lg="24" v-if="vidcents_value === 'total data'">
            <GChart
              type="PieChart"
              :data="vc_total_overview"
              :options="PieChartSett"
            />
          </el-col>
        </el-row>
        <el-row v-if="vidcents_value === 'by track'">
          <el-col :span="24" :lg="24" v-if="vidcents_value === 'by track'">
            <el-select v-model="vidcents_total.vc_campaign_track_id" placeholder="Tracks"
            @change="readTrackPieChart(vidcents_total)">
              <el-option
                v-for="item in vidcents_total"
                :key="item.vc_campaign_track_id"
                :label="item.sv_track_name"
                :value="item.vc_campaign_track_id"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="24" :lg="24" v-if="vidcents_value === 'by track'">
            <GChart
              type="PieChart"
              :data="vc_tracks_campaign"
              :options="PieChartSett"
            />
          </el-col>
        </el-row>
        <el-row v-if="vidcents_value === 'total data'">
          <el-col
            class="tab-select"
            :span="24"
            :lg="24"
          >
            <h4>No. Tracks: {{ vidcents_total.length }}</h4>
            <el-table :data="vidcents_total" class="w100" stripe v-loading="loading">
              <el-table-column
                label="Track name"
                prop="sv_track_name"
                width="300"
                sortable
              ></el-table-column>
              <el-table-column
                label="Artist name"
                prop="sv_artist_name"
                sortable
              ></el-table-column>
              <el-table-column
                label="VidCents paid"
                prop="vc_paid"
                sortable
              ></el-table-column>
              <el-table-column
                label="VidCents rate"
                prop="vc_rate"
                sortable
              ></el-table-column>
              <el-table-column label="Start date" prop="created_at" sortable>
                <template slot-scope="props">
                  {{ props.row.created_at | date }}
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="Wallets overview" name="wallet_overview">
        <el-row>
          <el-date-picker
            v-model="reports_date_range"
            class="float-right mt10"
            type="daterange"
            unlink-panels
            range-separator="-"
            start-placeholder="Start date"
            end-placeholder="End date"
            :picker-options="dateRangeOptions"
            format="d MMMM yyyy"
            value-format="yyyy-MM-dd"
            @change="filter()"
          ></el-date-picker>
        </el-row>
        <el-row>
          <h1>
            VidCents label wallets overview - total data
          </h1>
          <el-col class="tab-select" :span="24" :lg="24">
            <h4>No. Label: {{labels.length}}</h4>
          </el-col>
          <el-col :span="24">
            <el-table show-summary :data="labels.data" class="w100" stripe>
              <el-table-column
                label="Label name"
                prop="name"
                width="300"
                sortable
              ></el-table-column>
              <el-table-column
                label="Date of Payment"
                prop="videos"
                sortable
              ></el-table-column>
              <el-table-column
                label="Budget - VidCents"
                prop="views"
                sortable
              ></el-table-column>
              <el-table-column
                label="Budget - USD currency"
                prop="subscribers"
                sortable
              ></el-table-column>
              <el-table-column
                label="Paid by date"
                prop="date"
                sortable
              ></el-table-column>
              <el-table-column
                label="Paid out - VidCents"
                prop="date"
                sortable
              ></el-table-column>
              <el-table-column
                label="Paid out - USD currency"
                prop="subscribers"
                sortable
              ></el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="VidCents - funds" name="vidcents_funds">
        <el-row>
          <el-date-picker
            v-model="reports_date_range"
            class="float-right mt10"
            type="daterange"
            unlink-panels
            range-separator="-"
            start-placeholder="Start date"
            end-placeholder="End date"
            :picker-options="dateRangeOptions"
            format="d MMMM yyyy"
            value-format="yyyy-MM-dd"
            @change="filter()"
          ></el-date-picker>
        </el-row>
        <el-row>
          <h1>VidCents - funds</h1>
        </el-row>
        <el-row>
          <el-select v-model="choosen_label" placeholder="Labels">
            <el-option
              v-for="item in labels.data"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-row>
        <el-row>
          <el-col class="tab-select" :span="24" :lg="24">
            <h4>No. Campaign: 0</h4>
          </el-col>
          <el-col :span="24">
            <el-tabs v-model="vc_funds" type="border-card">
              <el-tab-pane name="campaign_funds" label="Campaign">
                <el-table show-summary :data="vidcents" class="w100" stripe>
                  <el-table-column
                    label="Campaign name"
                    prop="category_name"
                    width="300"
                    sortable
                  ></el-table-column>
                  <el-table-column
                    label="Date of payment"
                    prop="videos"
                    sortable
                  ></el-table-column>
                  <el-table-column
                    label="Budget - VidCents"
                    prop="views"
                    sortable
                  ></el-table-column>
                  <el-table-column
                    label="Budget - USD currency"
                    prop="subscribers"
                    sortable
                  ></el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane name="tracks_funds" label="Tracks">
                <el-table :data="vidcents" class="w100" stripe>
                  <el-table-column
                    label="Track name"
                    prop="track_name"
                    width="300"
                    sortable
                  ></el-table-column>
                  <el-table-column
                    label="Date of payment"
                    prop="videos"
                    sortable
                  ></el-table-column>
                  <el-table-column
                    label="Budget - VidCents"
                    prop="views"
                    sortable
                  ></el-table-column>
                  <el-table-column
                    label="Budget - USD currency"
                    prop="subscribers"
                    sortable
                  ></el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { GChart } from 'vue-google-charts'
import format from 'date-fns/format'
import subDays from 'date-fns/subDays'
import addDays from 'date-fns/addDays'

export default {
  components: {
    GChart
  },

  data() {
    return {
      choosen_label: null,
      vidcents: [],
      reports_date_range: [
        format(subDays(new Date(), 7), 'yyyy-MM-dd'),
        format(addDays(new Date(), 1), 'yyyy-MM-dd')
      ],
      today: format(new Date(), 'dd.MM.yyyy'),
      tabPosition: 'left',
      active_vctab: 'collective_overview',
      vc_overview: 'tracksWithVC',
      vc_funds: 'campaign_funds',
      campaings_value: 'all',
      campaings_options: [
        {
          value: 'all',
          label: 'All'
        },
        {
          value: 'by label',
          label: 'By Label'
        },
        {
          value: 'by category',
          label: 'By Category'
        },
        {
          value: 'by channel',
          label: 'By Channel'
        }
      ],
      vidcents_value: 'total data',
      vidcents_options: [
        {
          value: 'total data',
          label: 'All'
        },
        {
          value: 'by label',
          label: 'By Label'
        },
        {
          value: 'by campaing',
          label: 'By Campaigns'
        },
        {
          value: 'by track',
          label: 'By Track'
        }
      ],
      collective_options: [
        {
          value: 'vc_views',
          label: 'VC Views'
        },
        {
          value: 'vc_available',
          label: 'VC Available'
        },
        {
          value: 'vc_spent',
          label: 'VC Spent'
        },
        {
          value: 'active_track_campaigns',
          label: 'Active track campaigns'
        },
        {
          value: 'yt_video_no',
          label: 'Number of Videos'
        }
      ],
      collective_value: 'vc_views',
    }
  },

  computed: {
    ...mapState('reportsVC', [
      'loading',
      'active_track_campaigns',
      'vc_spent',
      'vc_views',
      'vc_available',
      'yt_video_no',
      'sv_nr_tracks',
      'LineChartSett',
      'PieChartSett',
      'vidcents_total',
      'user_wallets',
      'track_campaign',
      'label_campaign',
      'label'
    ]),
    ...mapState('vcLabel', ['labels']),

    ...mapGetters('reportsVC', ['vc_total_overview', 'vc_tracks_campaign', 'vc_label'])
  }, 

  methods: {
    ...mapActions('reportsVC', ['readCollective', 'readTotal', 'readUserWallets', 'readTrackCampaign', 'readLabel']),
    // ...mapMutations('reports', ['setDateRange']),

    readTrackPieChart(data) {
      this.readTrackCampaign({
        id: data.vc_campaign_track_id
      })
    },

    tabClick(tab) {
      if (tab.name === 'cp_overview' && this.active_track_campaigns.length == 0) this.readCollective('active_track_campaigns')
      if (tab.name === 'vc_overview' && this.active_track_campaigns.length == 0) this.readCollective('active_track_campaigns')
      if (tab.name === 'vc_overview' && this.vidcents_total.length == 0) this.readTotal()
      if (tab.name === 'vc_overview' && this.sv_nr_tracks.length == 0) this.readCollective('sv_nr_tracks')
      if (tab.name === 'wallet_overview' && this.vidcents_total.length == 0) this.readUserWallets()
    },

    showCollectiveData(value) {
      if (value === 'active_track_campaigns' && this.active_track_campaigns.length == 0) this.readCollective('active_track_campaigns')
      if (value === 'vc_spent' && this.vc_spent.length == 0) this.readCollective('vc_spent')
      if (value === 'vc_views' && this.vc_views.length == 0) this.readCollective('vc_views')
      if (value === 'vc_available' && this.vc_available.length == 0) this.readCollective('vc_available')
      if (value === 'yt_video_no' && this.yt_video_no.length == 0) this.readCollective('yt_video_no')
    },
  }
}
</script>

<style scoped>

h1 {
  text-align: center;
  font-weight: 200;
  font-size: 1.7rem;
}

h4 {
  text-align: left;
}

.el-select {
  float: right;
  margin-right: 1rem;
}

.el-col {
  margin: 0;
}

.pb-5 {
  padding-bottom: 2rem;
}
</style>
